import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setMobileHomeLength } from '../../redux/modules/mobilehome';
import Dropdown from '../../components/Dropdown';

class TotalMobileHomeFee extends Component {
  constructor(props) {
    super(props);
    this.onLengthSelect = this.onLengthSelect.bind(this);
  }

  onLengthSelect(event) {
    if (this.props.showMobileHomeRow) {
      this.props.setMobileHomeLength(event.target.value);
    }
  }

  getLengthText() {
    const lengths = ['Single-wide (x1)', 'Double-wide (x2)', 'Triple-wide (x3)'];
    return lengths[this.props.mobileHomeLength - 1];
  }

  render() {
    const { mobileHomeLength, showMobileHomeRow } = this.props;
    const options = [
      ['Single-wide Mobile Home', 1],
      ['Double-Wide Mobile Home (double fees)', 2],
      ['Triple-wide Mobile Home (triple fees)', 3],
    ];

    return (
      <div className="Row Registration-mobileHomeRow" style={{ display: showMobileHomeRow ? 'block' : 'none' }}>

        <input
          className="Row-total Row-totalText"
          value={this.getLengthText()}
          readOnly
          tabIndex="-1"
        />

        <Dropdown
          id="mobileHomeLength"
          options={options}
          tooltip="Select the length of the Mobile Home"
          onChange={this.onLengthSelect}
          selectedValue={mobileHomeLength}
          className="Dropdown Row-dropdown no-print"
        />

        <b> Mobile Home Length</b>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mobileHomeLength: state.mobilehome.mobileHomeLength,
    showMobileHomeRow: state.registration.showMobileHomeRow,
  };
};

export default connect(mapStateToProps, { setMobileHomeLength })(TotalMobileHomeFee);



// WEBPACK FOOTER //
// ./src/containers/registration/TotalMobileHomeFee.js